<div class="auth-form-card">
  <div class="auth-form-header">
    <img
      src="/assets/logos/cyflare-one-logo-new-colors.png"
      alt="Cyflare One"
      class="auth-form-logo"
    />
    <h2>Two-Factor Authentication</h2>
  </div>

  <form
    [formGroup]="loginForm"
    (ngSubmit)="submit()"
  >
    <p class="auth-form-description">
      Enter the 6 digit code from your authenticator app
    </p>

    <app-error-message></app-error-message>

    <div class="auth-form-field">
      <kendo-floatinglabel text="Authenticator App Code">
        <input
          kendoTextBox
          class="form-control"
          formControlName="oneTimeCode"
          autofocus
        />
      </kendo-floatinglabel>
    </div>

    <div class="auth-form-submit">
      <button
        kendoButton
        class="cyflare-btn-primary cyflare-btn-lg cyflare-btn-block"
        type="submit"
      >
        Submit
      </button>
    </div>

    <div class="auth-form-footer">
      <span>Having trouble signing in?</span>
      <a
        href="mailto:support@cyflare.com"
        kendoButton
        fillMode="clear"
      >
        Contact Us
      </a>
    </div>

    <div class="auth-form-secondary">
      <button
        kendoButton
        class="cyflare-btn-secondary cyflare-btn-lg cyflare-btn-block"
        type="button"
        (click)="back()"
      >
        Go Back
      </button>
    </div>
  </form>
</div>
